<div class="modal-header">
  <h5 class="modal-title">{{ order.id ? 'Chỉnh sửa' : 'Thêm' }} Đơn Hàng</h5>
  <button type="button" class="close" aria-label="Đóng" (click)="onCancelClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form>
    <div class="form-group">
      <label for="orderNumber">
        Số Đơn Hàng
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Nhập số đơn hàng duy nhất."></i>
      </label>
      <input type="text" class="form-control" id="orderNumber" [(ngModel)]="order.orderNumber" name="orderNumber" placeholder="ví dụ: ORD-12345">
    </div>
    <div class="form-group">
      <label for="orderDate">
        Ngày Đặt Hàng
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Chọn ngày đặt hàng."></i>
      </label>
      <input type="date" class="form-control" id="orderDate" [(ngModel)]="order.orderDate" name="orderDate" placeholder="ví dụ: 2023-10-03">
    </div>
    <div class="form-group">
      <label for="vendor">
        Nhà Cung Cấp
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Chọn nhà cung cấp cho đơn hàng này."></i>
      </label>
      <select class="form-control" id="vendor" [(ngModel)]="order.vendor" name="vendor">
        <option *ngFor="let vendor of vendors" [ngValue]="vendor">{{ vendor.name }}</option>
      </select>
    </div>
    <div class="form-group">
      <label for="totalCost">
        Tổng Chi Phí
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Nhập tổng chi phí của đơn hàng."></i>
      </label>
      <input type="number" class="form-control" id="totalCost" [(ngModel)]="order.totalCost" name="totalCost" step="0.01" placeholder="ví dụ: 99.99">
    </div>
    <div class="form-group">
      <label for="status">
        Trạng Thái
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Nhập trạng thái hiện tại của đơn hàng."></i>
      </label>
      <select class="form-control" id="status" [(ngModel)]="order.status" name="status">
        <option value="" disabled selected>Chọn Trạng Thái</option>
        <option value="Pending">Đang Chờ</option>
        <option value="Cancelled">Đã Hủy</option>
        <option value="Shipped">Đã Gửi</option>
        <option value="Delivered">Đã Giao</option>
    </select>
    </div>
    <div class="form-group">
      <label for="notes">
        Ghi Chú
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Thêm bất kỳ ghi chú bổ sung nào về đơn hàng."></i>
      </label>
      <textarea class="form-control" id="notes" [(ngModel)]="order.notes" name="notes" placeholder="ví dụ: Giao hàng trước cuối tuần"></textarea>
    </div>
    <div class="form-group">
      <label for="contract">
        Hợp Đồng
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Chọn hợp đồng liên quan."></i>
      </label>
      <select class="form-control" id="contract" [(ngModel)]="order.contract" name="contract">
        <option *ngFor="let contract of contracts" [ngValue]="contract">{{ contract.contractNumber }}</option>
      </select>
    </div>
    <div class="form-group">
      <label for="invoice">
        Hóa Đơn
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Chọn hóa đơn liên quan."></i>
      </label>
      <select class="form-control" id="invoice" [(ngModel)]="order.invoice" name="invoice">
        <option *ngFor="let invoice of invoices" [ngValue]="invoice">{{ invoice.invoiceNumber }}</option>
      </select>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="onCancelClick()">Hủy</button>
  <button type="button" class="btn btn-outline-primary" (click)="onSaveClick()">Lưu</button>
</div>

